import * as React from 'react'
import classNames from 'classnames'
import './index.css'
import Flex from 'components/Flex'

export default function Chip ({
  className,
  ...rest
}) {
  className = classNames(className, {
    chip: true
  })

  return (
    <Flex
      className={className}
      {...rest}
    />
  )
}
